import React from "react";
import Icon from "Shared/Icon";
import classnames from "classnames";
import * as styles from "./base.scss";
import { on } from "SiteLayout/Root";
import DropDownItem from "./DropDownItem";
import DropDownSeparator from "./DropDownSeparator";
import DropDownWrapper from "./DropDownWrapper";
import ViewTracker from "Shared/ViewObserver/ViewTracker";
export { DropDownItem, DropDownSeparator, DropDownWrapper };
export var Apperance;
(function (Apperance) {
    Apperance[Apperance["Normal"] = 0] = "Normal";
    Apperance[Apperance["Big"] = 1] = "Big";
    Apperance[Apperance["Small"] = 2] = "Small";
})(Apperance || (Apperance = {}));
const validChildren = [DropDownItem, DropDownSeparator, DropDownWrapper];
class DropDownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.getListHeight = (children) => {
            const childCount = this.props.childCount ||
                (!!children ? React.Children.count(children) : 0);
            return !!children ? Math.max(140, Math.min(childCount * 35, 350)) : 0;
        };
        this.hideOptions = () => {
            !!this.props.onClose && this.props.onClose();
            this.setState({ hideOptions: true });
            this.timer = setTimeout(() => {
                this.setState({ isOpen: false, hideOptions: false });
            }, 300);
        };
        this.onClose = (onCloseFn) => (e) => {
            if (onCloseFn) {
                this.hideOptions();
                return onCloseFn();
            }
            else {
                this.hideOptions();
            }
        };
        this.toggleOpen = () => {
            if (!!this.props.disabled)
                return;
            if (!this.state.isOpen) {
                !!this.props.onOpen && this.props.onOpen();
                this.setState({ isOpen: true });
            }
            else {
                this.hideOptions();
            }
        };
        this.close = (childClick) => (e) => {
            if (e) {
                e.stopPropagation();
            }
            const maybePromise = childClick && childClick(e);
            if (maybePromise instanceof Promise) {
                return maybePromise;
            }
            else {
                this.setState({ isOpen: false });
            }
        };
        this.state = { isOpen: false, hideOptions: false, listHeight: 350 };
    }
    componentDidMount() {
        const listHeight = this.getListHeight(this.props.children);
        this.setState({ listHeight: listHeight });
        this.unbindRootClick = on("click", () => {
            if (this.state.isOpen) {
                this.hideOptions();
            }
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.children !== nextProps.children) {
            const listHeight = this.getListHeight(nextProps.children);
            this.setState({ listHeight: listHeight });
        }
    }
    componentWillUnmount() {
        this.unbindRootClick && this.unbindRootClick();
        clearTimeout(this.timer);
    }
    render() {
        const { title, children, className, optionsClassName, appearance } = this.props;
        return (React.createElement(ViewTracker, { onHide: (visible) => this.hideOptions(), once: false },
            React.createElement("div", { className: classnames(styles.base, appearance == Apperance.Big
                    ? styles.base__big
                    : styles.base__normal, className, {
                    [styles.disabled]: !!this.props.disabled,
                    [styles.base__small]: appearance == Apperance.Small,
                }) },
                React.createElement("div", { className: classnames(styles.innerWrapper, { [styles.open]: this.state.isOpen }, {
                        [styles.innerWrapper__invalid]: this.props.isInvalid && !this.state.isOpen,
                    }) },
                    React.createElement("div", { className: classnames(styles.control, {
                            [styles.open]: this.state.isOpen,
                        }), onClick: this.toggleOpen },
                        React.createElement("span", null, title),
                        React.createElement("span", { className: styles.arrow },
                            React.createElement(Icon, { appearance: "sans", name: "arrow-down" }))),
                    this.state.isOpen && (React.createElement("div", { className: classnames({ [styles.hideOptions]: this.state.hideOptions }, styles.options, optionsClassName), style: {
                            "--listHeight": `${this.state.listHeight}px`,
                        } }, React.Children.map(children, (c) => {
                        if (c === null) {
                            return;
                        }
                        if (c.type === DropDownItem) {
                            return React.cloneElement(c, {
                                onClick: this.close(c.props.onClick),
                                onClose: this.onClose(c.props.onClose),
                            });
                        }
                        if (validChildren.find((v) => c.type === v)) {
                            return React.cloneElement(c, {
                                onClose: this.onClose(c.props.onClose),
                            });
                        }
                    })))))));
    }
}
export default DropDownMenu;
